import React, {PropTypes} from 'react';
import ErrorContainer from '../ErrorContainer';
import LiveInputField from './../Input/LiveInputField';
import {ListProps} from '../../../utilites/helpers/crudListHelper';
import ListCountries from './List';
import shallowEqual from 'fbjs/lib/shallowEqual';
import debounce from 'lodash/debounce';
import IconSearch from '../../../components/Icons/IconSearch';
import InputToggle from '../InputToggle';

class Countries extends React.PureComponent {
  static propTypes = Object.assign({}, ListProps, {
    label: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    visited: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.array,
    leftItems: PropTypes.node,
    rightItems: PropTypes.node,
    onChange: PropTypes.func
  });

  static defaultProps = {
    value: []
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  state = {
    checked: [],
    unchecked: [],
    filterQuery: ''
  };

  style = {
    filterInput: {width: '100%', paddingLeft:'40px'},
    leftIcon:{
      position: 'absolute',
      top: 0,
      left: 8
    }
  };

  constructor() {
    super(...arguments);

  }

  _filterCountries = (value) => {
    this.setState({filterQuery: value.toLowerCase()});
  };

  _debounceFilterCountries = debounce(this._filterCountries, 200);

  _handleFilterCountries = (value) => {
    this._debounceFilterCountries(value);
  };

  componentWillMount() {
    this.props.fetch();
    this._prepareSeparateList(this.props);
  }

  _prepareSeparateList(props, filterQuery = '') {
    let {value, items} = props;
    this.setState(this._splitChecked(value, this._createCountryMap(items, filterQuery)));
  }

  _handleAddCountry = (id) => {
    let {value, onChange} = this.props;
    value = value || [];
    value.push(id);
    onChange(value);
  };

  _handleDeleteCountry = (code) => {
    let {value, onChange} = this.props;
    const indexChecked = value.indexOf(code);

    if (indexChecked !== -1) {
      onChange(value.slice(0, indexChecked).concat(value.slice(indexChecked+1)));
    }
  };

  _handleDeleteAllCountries = () => {
    let {value, onChange} = this.props;
    const {checked, filterQuery} = this.state;
    if (filterQuery !== '') {
      let currentMap = this._createCountryMap(checked);
      onChange(value.filter((current) => currentMap[current] === undefined));
    } else {
      onChange([]);
    }

  };

  _handleAddAllCountries = () => {
    let {value, items, onChange} = this.props;
    const {unchecked, filterQuery} = this.state;
    if (filterQuery !== '') {
      onChange(value.concat(unchecked.map((current) => current.id)));
    } else {
      onChange(items.map(county => county.id));
    }
  };
  componentDidUpdate(prevProps) {
    if(!this.props.value.length && prevProps.items.length == 0 && this.props.items.length > 0){
      this._handleAddAllCountries()
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (!shallowEqual(this.props, nextProps) || this.state.filterQuery !== nextState.filterQuery) {
      this._prepareSeparateList(nextProps, nextState.filterQuery);
    }
  }
  toggleCountries(){
    const toggleIsOn = this.props.items.length === this.state.checked.length
    if(toggleIsOn){
      this._handleDeleteAllCountries()
    } else {
      this._handleAddAllCountries()
    }
  }
  render() {
    return (
      <ErrorContainer {...this.props}
                      labelStyle={{position: 'relative'}}>
        {this._renderField()}
      </ErrorContainer>
    );
  }

  _createCountryMap(list, filterQuery) {
    if (filterQuery) { filterQuery = filterQuery.trim() }
    return list.reduce((previousValue, country) => {
      if (country.name.toLowerCase().match(filterQuery)) {
        previousValue[country.id] = country;
      }
      return previousValue;
    }, {});
  }

  _splitChecked(value, countryObject) {
    let countryObjectClone = Object.assign({}, countryObject);
    return {
      checked: (value || []).reduce((prev, code) => {
        if (countryObject[code]) {
          prev.push(countryObject[code]);
          delete countryObjectClone[code];
        }
        return prev;
      }, []),
      unchecked: Object.values(countryObjectClone)
    };
  }

  _renderField() {
    let {placeholder, disabled} = this.props;
    let {checked, unchecked} = this.state;
    let {baseTheme: {palette: {accent1Color}}} = this.context.muiTheme;
    const toggleIsOn = this.props.items.length === checked.length
    return (
      <div>
        { toggleIsOn
          ? <InputToggle
                      style={{ cursor: 'pointer', marginBottom: 20 }}
                      label={toggleIsOn ? 'Show in all countries' : 'No selected countries'}
                      onChange={this.toggleCountries.bind(this)}
                      disabled={ disabled }
                      labelPosition="right"
                      value={toggleIsOn}
                    /> : null
        }
        {
        !toggleIsOn ? <div>
          <LiveInputField style={this.style.filterInput}
                          leftIcon={
                            <span style={this.style.leftIcon}>
                                <IconSearch color={accent1Color}/>
                            </span>
                          }
                          autoComplete='false'
                          placeholder={placeholder}
                          onChange={this._handleFilterCountries}
          />
          <ListCountries
            countries={checked}
            filter={true}
            disabled={disabled}
            onClickByItem={this._handleDeleteCountry}
            onDeleteAll={this._handleDeleteAllCountries}

          />
          <ListCountries
            countries={unchecked}
            disabled={disabled}
            onClickByItem={this._handleAddCountry}
            onAddAll={this._handleAddAllCountries}
          />
        </div> : null
        }
      </div>
    );
  }
}

export default Countries;



// WEBPACK FOOTER //
// ./src/components/form/Countries/Countries.jsx